import React from 'react';
import s from './bucket.module.css';

const Bucket = ({ children }) => {

  return (
    <div className={s.cont}>
      <div className={s.fixMargin}>
        <div className='d-flex justify-content-center align-content-around flex-wrap'>
          {children}
        </div>
      </div>
    </div>
  );

};

export default Bucket;
